import { Component, OnInit, Input } from '@angular/core';

import {CartService} from 'src/app/shared/services/cart.service';
import {ApiService} from '../../../../services/api.service';
import {Data} from '../../../../classes/app.models';
import { BudgetService } from 'src/app/shared/services/budget.service';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'indiapicture-cart-menu',
    templateUrl: './cart-menu.component.html',
    styleUrls: ['./cart-menu.component.scss']
})

export class CartMenuComponent implements OnInit {
    /** The studio header shows icons only; the site header keeps its captions. */
    @Input() showLabel = true;


    public cartData = new Data(
        [],
        0,
        0
    );
    private currentUser: any;

    constructor(public cartService: CartService,
                public apiService: ApiService,
                public budgetService: BudgetService,
                public authService: AuthenticationService,
                public toastService: ToastrService) {
        this.cartData = apiService.Data;
        this.authService.currentUser?.subscribe(x => this.currentUser = x);
     //  console.log(this.cartData);
    }

    ngOnInit(): void {
    }

    removeFromCart(event: Event, product: any) {
        event.preventDefault();
        if (this.currentUser && this.currentUser.user_type == 'BUDGET') {
            this.budgetService.removeCartProduct(JSON.stringify(product), this.currentUser.customers_id).subscribe(() => {
                this.budgetService.getCartList(this.currentUser.customers_id).subscribe((res: any) => {
                    this.cartService.addToApiService(res['data']);
                });
                this.toastService.success('Product removed from Cart.');
            }, () => {
                this.toastService.error('Error in removing product from the cart');
            });
        } else {
            this.cartService.removeFromCart(product);
        }
    }
}
